/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useMemo, useEffect, useRef, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import theme from "../../theme/settings";
import Typography from "../typography";
const color = [`${theme.colors.semantic.warning}`, `${theme.colors.semantic.success}`, `${theme.colors.semantic.danger}`];
const colorNum = {
  Scheduled: 0,
  Started: 1,
  Cancel: 2
};
const InterviewStatus = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  disabled,
  readOnly,
  chosen,
  onClick,
  onChoose
}, ref) => {
  if (!ref) {
    ref = useRef(null);
  }
  const checkText = css`
            display: inline-flex;
            color: ${disabled ? theme.colors.text.disabled : theme.colors.system.rest};
            div:nth-of-type(1):hover {
                color: ${color[0]};
            }
            div:nth-of-type(2):hover {
                color: ${color[1]};
            }
            div:nth-of-type(3):hover {
                color: ${color[2]};
            }
        `;
  const checkTextItemText = css`
            margin-left: 10px;
        `;
  const checkTextDivider = css`
            margin: 2px 19px;
            width: 2px;
            height: 16px;
            background: ${theme.colors.system.rest};
            border-radius: 1px;
        `;
  const onClickItem = (e, index) => {
    const clickedItem = ref.current.querySelectorAll('div');
    if (readOnly || clickedItem[index].style.color) return;
    clickedItem.forEach((el, i) => {
      if (i === index) {
        el.style.color = color[index];
      } else if (el.style.color) {
        el.style.color = null;
      }
    });
    e.selectedItem = {
      value: e.target.textContent,
      index
    };
    if (onClick) onClick(e);
    if (onChoose) onChoose(e);
  };
  useEffect(() => {
    ref.current.querySelectorAll('div').forEach((el, i) => {
      if (i === chosen || el.textContent === chosen) {
        el.style.color = color[isNaN(chosen) ? colorNum[chosen] : chosen];
      } else if (el.style.color) {
        el.style.color = null;
      }
    });
  }, [chosen]);
  return useMemo(() => jsx("div", {
    css: checkText,
    ref: ref
  }, jsx(Typography, {
    type: 'p2',
    style: {
      lineHeight: '20px',
      color: `${disabled ? `${theme.colors.text.disabled} !important` : 'inherit'}`,
      cursor: `${readOnly ? 'default' : 'pointer'}`,
      pointerEvents: `${disabled ? 'none' : 'auto'}`,
      userSelect: 'none'
    },
    mapping: 'div',
    onClick: e => onClickItem(e, 0)
  }, jsx("span", {
    css: checkTextItemText
  }, "Scheduled")), jsx("span", {
    css: checkTextDivider
  }), jsx(Typography, {
    type: 'p2',
    style: {
      lineHeight: '20px',
      color: `${disabled ? `${theme.colors.text.disabled} !important` : 'inherit'}`,
      cursor: `${readOnly ? 'default' : 'pointer'}`,
      pointerEvents: `${disabled ? 'none' : 'auto'}`,
      userSelect: 'none'
    },
    mapping: 'div',
    onClick: e => onClickItem(e, 1)
  }, jsx("span", {
    css: checkTextItemText
  }, "Started")), jsx("span", {
    css: checkTextDivider
  }), jsx(Typography, {
    type: 'p2',
    style: {
      lineHeight: '20px',
      color: `${disabled ? `${theme.colors.text.disabled} !important` : 'inherit'}`,
      cursor: `${readOnly ? 'default' : 'pointer'}`,
      pointerEvents: `${disabled ? 'none' : 'auto'}`,
      userSelect: 'none'
    },
    mapping: 'div',
    onClick: e => onClickItem(e, 2)
  }, jsx("span", {
    css: checkTextItemText
  }, "Cancel"))), []);
}));
InterviewStatus.propsTypes = {
  /** Prevent all event if true */
  disabled: PropTypes.bool,
  /** the displayed chosen for each change */
  chosen: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** The function will run to return a value of CheckText Component */
  onClick: PropTypes.func,
  /** The function will run to return a value of CheckText Component */
  onChoose: PropTypes.func
};
export default InterviewStatus;